<div id="muntins-layout-draw" #parent>
    <icc-draw [details]="drawService.details" [options]="drawOptions" fitTo="width" iccDrawResize [drawWidth]="drawService.details.width" [drawHeight]="drawService.details.height" [parentElement]="parent"></icc-draw>
</div>
